export default __webpack_public_path__ + "static/media/photo-1.08c74fe4.jpg";